"use strict";
// Copyright © Veeam Software Group GmbH
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SideFilterItem = void 0;
const react_1 = __importDefault(require("react"));
const styled_components_1 = __importDefault(require("styled-components"));
const FormGroupContext_1 = require("../FormGroupContext");
const helpers_1 = require("../helpers");
const StackView_1 = require("../StackView");
const Text_1 = require("../Text");
const View_1 = require("../View");
const Wrapper = (0, styled_components_1.default)(StackView_1.StackView) `
    padding: 0 ${helpers_1.SPACING_M};
`;
const SideFilterItem = ({ disabled = false, title, contentRenderer }) => {
    return (react_1.default.createElement(Wrapper, { spaceFill: View_1.SPACE_FILL.all, direction: StackView_1.STACK_DIRECTION.column, gap: StackView_1.STACK_GAP.s },
        react_1.default.createElement(Text_1.Text, { weight: Text_1.TEXT_WEIGHT.bold, truncate: true }, title),
        react_1.default.createElement(FormGroupContext_1.FormGroupContextProvider, { value: { disabled } }, contentRenderer({ disabled }))));
};
exports.SideFilterItem = SideFilterItem;
//# sourceMappingURL=SideFilterItem.js.map